export class MissingTokenError extends Error {
  public message = '';

  public name = 'MissingTokenError';

  public stack = '';
}
